export interface StepConfig {
  number: number;
  title: string;
  description: string;
}

export const steps: StepConfig[] = [
  {
    number: 1,
    title: 'Setup Data Source',
    description: 'Configure your data connection',
  },
  {
    number: 2,
    title: 'Automatic Source Nexset',
    description: 'Generate intelligent data structure',
  },
  {
    number: 3,
    title: 'Optional Setup Transforms and Data Contract',
    description: 'Configure data transformations',
  },
  {
    number: 4,
    title: 'Deliver Data to Target',
    description: 'Send data to destination',
  },
];
